var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('video',{attrs:{"src":_vm.respRandomVideo,"autoplay":"","muted":"","loop":"","preload":"auto"},domProps:{"muted":true}}),_c('div',{staticClass:"menu-grad"}),_c('div',{staticClass:"arrow-bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }